import { render, staticRenderFns } from "./EReason.vue?vue&type=template&id=3a1fb9d7"
import script from "./EReason.vue?vue&type=script&lang=js"
export * from "./EReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports